import { fromJS } from "immutable"
import {
  GET_LIST_QUESTIONS_WATCHER,
  GET_LIST_QUESTIONS_SUCCESS,
  GET_LIST_QUESTIONS_FAILED,
  GET_LIST_ONLY_QUESTIONS_SUCCESS,
  GET_LIST_ONLY_QUESTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingQuestions: true,
  questions: [],
  onlyQuestions: [],
})

function widgetQualitativeQuestionReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_QUESTIONS_WATCHER:
      return state.set("isLoadingQuestions", true)

    case GET_LIST_QUESTIONS_SUCCESS:
      return state
        .set("isLoadingQuestions", false)
        .set("questions", action.payload)

    case GET_LIST_QUESTIONS_FAILED:
      return state.set("isLoadingQuestions", false).set("questions", [])

    case GET_LIST_ONLY_QUESTIONS_SUCCESS:
      return state
        .set("isLoadingQuestions", false)
        .set("onlyQuestions", action.payload)

    case GET_LIST_ONLY_QUESTIONS_FAILED:
      return state.set("isLoadingQuestions", false).set("onlyQuestions", [])

    default:
      return state
  }
}

export default widgetQualitativeQuestionReducer
